import CustomAvatar from 'components/global/CustomAvatar'
import CustomModal from 'components/global/CustomModal'
import React, { useEffect, useState } from 'react'
import { leagueGamesStore } from 'state/league/leageGames'
import '../styles/mainmodals/selectGame.scss'
import { useGetLeagueGames } from 'api/league/leagueGames/leagueGames'
import { leagueEventStore } from 'state/league/leagueEvent'
import Spinner from 'components/Spinner'
import { convertMinutesToLocalTime } from 'helper/utility'
import moment from 'moment'
import {
  LeagueGameRespType,
  LeagueGamesByRoundDate,
} from 'types/league/leagueGame'

const SelectGame: React.FC = () => {
  const { leagueData } = leagueEventStore(store => ({ leagueData: store.leagueData }))
  const {
    selectGameModal,
    setSelectGameModal,
    setAddScoreModal,
    setSelectedGame,
  } = leagueGamesStore(store => ({
    selectGameModal: store.selectGameModal,
    setSelectGameModal: store.setSelectGameModal,
    setAddScoreModal: store.setAddScoreModal,
    setSelectedGame: store.setSelectedGame,
  }))
  const [params] = useState({
    leagueId: leagueData?._id || '',
  })

  const {
    data: gamesByLeagueId,
    isLoading: gamesLoading,
    isFetching: gamesFetching,
    refetch: refetchGames,
  } = useGetLeagueGames(params)

  useEffect(() => {
    refetchGames()
  }, [params])

  const closeModal = () => {
    setSelectGameModal(false)
  }

  const handleSelect = (game: LeagueGameRespType) => {
    setSelectedGame(game)
    setSelectGameModal(false)
    setAddScoreModal(true)
  }

  return (
    <>
      <CustomModal
        openModal={selectGameModal}
        isCloseModalCustom
        closeModal={closeModal}
        title="Select game"
        footer={false}
      >
        <>
          {gamesLoading || gamesFetching ? (
            <div>
              <Spinner />
            </div>
          ) : (
            <>
              {gamesByLeagueId.length ? (
                <>
                  {gamesByLeagueId.map((gameRounds: LeagueGamesByRoundDate) => {
                    return (
                      <div
                        className="round-box mt-10 pr-10px"
                        key={gameRounds.round}
                      >
                        <h3 className="text-14 w-600">
                          Round {gameRounds.round}
                        </h3>
                        {gameRounds.dates.map(gameDates => {
                          return (
                            <>
                              <div
                                className="date-container"
                                key={gameDates.date}
                              >
                                <h4>
                                  {moment(gameDates.date).format(
                                    'dddd, MMMM DD',
                                  )}
                                </h4>
                              </div>
                              {gameDates.games.map(game => {
                                return (
                                  <div className="game-box" key={game._id}>
                                    <div className="team-time-container">
                                      <div className="team">
                                        <CustomAvatar
                                          size={40}
                                          src={
                                            game.homeTeam.team.profilePhoto
                                              ?.thumb
                                          }
                                          name={game.homeTeam.team.name}
                                        />
                                        <b>{game.homeTeam.team.name}</b>
                                      </div>
                                      <div className="time">
                                        <span>{game.courtFieldNumber}</span>
                                        <b>
                                          {convertMinutesToLocalTime(
                                            game.timings.startTime,
                                          )}
                                        </b>
                                      </div>
                                      <div className="team">
                                        <CustomAvatar
                                          size={40}
                                          src={
                                            game.awayTeam.team.profilePhoto
                                              ?.thumb
                                          }
                                          name={game.awayTeam.team.name}
                                        />
                                        <b>{game.awayTeam.team.name}</b>
                                      </div>
                                    </div>
                                    <button
                                      className="select-btn"
                                      onClick={() => handleSelect(game)}
                                    >
                                      Select
                                    </button>
                                  </div>
                                )
                              })}
                            </>
                          )
                        })}
                      </div>
                    )
                  })}
                </>
              ) : (
                <div>No games created</div>
              )}
            </>
          )}
        </>
      </CustomModal>
    </>
  )
}

export default SelectGame
